import { render, staticRenderFns } from "./CookieSection.vue?vue&type=template&id=1de84c20&"
import script from "./CookieSection.vue?vue&type=script&lang=js&"
export * from "./CookieSection.vue?vue&type=script&lang=js&"
import style0 from "./CookieSection.vue?vue&type=style&index=0&id=1de84c20&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports